import { useCallback, useEffect, useState } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import DropdownButton from "react-bootstrap/DropdownButton";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";

import {
  load_patient_data_from_id,
  load_patient_list,
} from "../actions/clinic_content";
const debounce = (func, wait) => {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
};
const PeopleSearchDropdown = ({
  quoteData,
  setQuoteData,
  alertPatient,
  setPatientData,
}) => {
  const [query, setQuery] = useState("");
  const [options, setOptions] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);

  const handleInputFocus = () => setShowDropdown(true);
  const handleInputBlur = (e) => {
    setTimeout(() => setShowDropdown(false), 150);
  };
  const debouncedFetchPatients = useCallback(
    debounce(async (q) => {
      const result = await load_patient_list({ textSearch: q });
      if (result) {
        setOptions(result);
      }
    }, 300),
    []
  );
  useEffect(() => {
    if (query) {
      debouncedFetchPatients(query);
    } else {
      setOptions([]);
    }
  }, [query, debouncedFetchPatients]);
  useEffect(() => {
    if (quoteData.patient) {
      const fetchPatient = async () => {
        const result = await load_patient_data_from_id(quoteData.patient);
        if (result) {
          setPatientData(result);
          setQuery(
            `${result.name || ""} ${result.first_lastname || ""} ${
              result.second_lastname || ""
            } - ${result.rut || ""}`
              .replace(/\s+/g, " ")
              .trim()
          );
        }
      };
      fetchPatient();
    }
    setQuery("");
  }, [quoteData.patient]);
  const handleSelect = (user) => {
    setQuoteData({ ...quoteData, patient: user.id });
    setQuery(`${user.name} ${user.lastnames} - ${user.rut}`);
    setOptions([]); // Clear dropdown
  };
  return (
    <div className="input-field">
      <Form.Label>
        Paciente
        <strong className="text-danger">*</strong>
        <span
          className={alertPatient ? "fst-italic m-2 text-danger" : "d-none"}
        >
          No valido.
        </span>
      </Form.Label>
      <InputGroup className="mb-3">
        <Form.Control
          aria-label="Text input with dropdown button"
          onChange={(e) => setQuery(e.target.value)}
          className={alertPatient ? "border border-danger " : ""}
          value={query}
          onFocus={handleInputFocus}
          onBlur={handleInputBlur}
        />

        <DropdownButton
          variant="outline-secondary"
          title=""
          id="input-group-dropdown-2"
          align="end"
          show={showDropdown}
        >
          {options.count > 0 ? (
            options.results?.map((user) => (
              <Dropdown.Item key={user.id} onClick={() => handleSelect(user)}>
                {user.name} {user.lastnames} - {user.rut}
              </Dropdown.Item>
            ))
          ) : (
            <Dropdown.Item>No hay resultados</Dropdown.Item>
          )}
        </DropdownButton>
      </InputGroup>
    </div>
  );
};

export default PeopleSearchDropdown;
